import noUiSlider from "nouislider";
import Collection from '../../generic/collection'

class RangeSlider {
    sliderValues = {
        "min": 0,
        "max": 10000
    }

    inputDirection = {
        min: 'min',
        max: 'max',
    }

    cfg = {
        start: [ 0, 3000 ],
        connect: true,
        range: this.sliderValues,
        margin: 1000,
        step: 1000,
        format: {
            from: function (formattedValue) {
                return Number(formattedValue);
            },
            to: function (numericValue) {
                return Math.round(numericValue);
            }
        },
    }

    constructor(instance) {
        this.instance = instance;
        const dataValue = this.instance.dataset.jsRangeslider;
        const sliderCfg = this.getCfg();
        if (sliderCfg) {
            this.cfg = {
                ...this.cfg,
                ...sliderCfg
            };
            console.log(this.cfg)
        }
        this.inputs = document.querySelectorAll(`[data-js-rangeslider-input=${ dataValue }]`)
        this.init();
    }

    getCfg() {
        const sliderCfg = JSON.parse(this.instance.getAttribute('data-js-rangeslider-cfg'));
        if (!sliderCfg) return;
        sliderCfg.format.from = new Function("return " + sliderCfg.format.from)();
        sliderCfg.format.to = new Function("return " + sliderCfg.format.to)();
        return sliderCfg;
    }

    createSlider() {
        this.noUiSlider = noUiSlider.create(this.instance, this.cfg);
    }

    updateSliderValue = ([ minValue, maxValue ]) => {
        this.inputs[0].value = new Intl.NumberFormat().format(minValue);
        this.inputs[1].value = new Intl.NumberFormat().format(maxValue);
    }

    onInputChange = (evt) => {
        const inputDirection = evt.target.dataset.jsRangesliderDir;
        const value = evt.target.value.replace(' ', '');

        if (inputDirection === this.inputDirection.max) {
            this.instance.noUiSlider.set([ null, value ])
        } else {
            this.instance.noUiSlider.set([ value, null ])
        }
    }

    init() {
        this.createSlider()
        this.instance.noUiSlider.on("update", this.updateSliderValue)
        this.inputs.forEach((input) => {
            input.addEventListener("change", this.onInputChange)
        })
    }
}

export class RangeSliderCollection extends Collection {
    static selectors = {
        instance: "[data-js-rangeslider]"
    }

    constructor() {
        super(RangeSliderCollection.selectors.instance, RangeSlider)
    }
}